import service from '@/utils/request'; // CreateStationOilGunInfo 创建油枪基础信息
// @Tags Station
// @Summary 创建油枪基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilGunModel true "创建油枪基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/oilGunInfo/create [post]

export var createStationOilGunInfo = function createStationOilGunInfo(data) {
  return service({
    url: '/stationManage/oilGunInfo/create',
    method: 'post',
    data: data
  });
}; // DeleteStationOilGunInfo 删除油枪信息
// @Tags Station
// @Summary 删除油枪信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilGunModel true "删除油枪信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /stationManage/oilGunInfo/delete [delete]

export var deleteStationOilGunInfo = function deleteStationOilGunInfo(data) {
  return service({
    url: '/stationManage/oilGunInfo/delete',
    method: 'post',
    data: data
  });
}; // DeleteStationOilGunInfoByIds 批量删除油枪信息
// @Tags Station
// @Summary 批量删除油枪信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油枪信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /stationManage/oilGunInfo/deleteByIds [delete]

export var deleteStationOilGunInfoByIds = function deleteStationOilGunInfoByIds(data) {
  return service({
    url: '/stationManage/oilGunInfo/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateStationOilGunInfo 更新油枪基础信息
// @Tags Station
// @Summary 更新油枪基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilGunModel true "更新油枪基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /stationManage/oilGunInfo/update [put]

export var updateStationOilGunInfo = function updateStationOilGunInfo(data) {
  return service({
    url: '/stationManage/oilGunInfo/update',
    method: 'put',
    data: data
  });
}; // FindStationOilGunInfo 根据id查询油枪基础信息
// @Tags Station
// @Summary 根据id查询油枪基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilGunModel true "根据id查询油枪基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /stationManage/oilGunInfo/find [get]

export var findStationOilGunInfo = function findStationOilGunInfo(params) {
  return service({
    url: '/stationManage/oilGunInfo/find',
    method: 'get',
    params: params
  });
}; // GetStationOilGunInfoList 分页获取油枪列表信息
// @Tags Station
// @Summary 分页获取油枪列表信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.StationOilGunInfoSearch true "分页获取油枪列表信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/oilGunInfo/getList [get]

export var getStationOilGunInfoList = function getStationOilGunInfoList(params) {
  return service({
    url: '/stationManage/oilGunInfo/getList',
    method: 'get',
    params: params
  });
};